<template>
	<header class="header">
        <div class="wrapper">
          <div class="left">
            <router-link to="/" class="logo">
              <img src="./../img/logo.svg" class="img"/>
            </router-link>
          </div>
          <div class="right">
            <div class="select-container" v-if="curr">
              <Select2 class="select2 single currency-select" v-model="curr"
                      @select="selectCurr($event)"
                      :placeholder="curr"
                      :options="currOptions"
              />
            </div>
            <ul class="nav">
              <li class="nav__item">
                <a @click="$parent.goToRules">
                  <span class="desc">Rules</span>
                </a>
              </li>
              <li class="nav__item">
                <router-link to="/contacts" class="desc">
                  Contact us
                </router-link>
              </li>
              <li class="nav__item">
                <router-link :to="getStoreUrl" class="desc">
                  Store
                </router-link>
              </li>
            </ul>
            <button @click="copyIp" class="button">{{ipCopied ? 'IP copied' : 'Join server'}}</button>
          </div>
        </div>
    </header>
</template>

<script>

import Select2 from 'vue3-select2-component';
export default {
	name: 'Header',
  props: ['activeCategory', 'currencyCode'],
  components: {
    Select2
  },
	data: function() {
		return {
      curr: '',
      ipCopied: false
		}
	},
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({text}) => text);
    },
    getStoreUrl() {
      // Check if activeCategory exists and has a url property
      if (this.activeCategory && this.activeCategory.url) {
        return '/store' + this.activeCategory.url;
      } else if (this.$parent && this.$parent.categories && this.$parent.categories.length > 0) {
        // If parent has categories, use the first one
        return '/store' + this.$parent.categories[0].url;
      } else {
        // Fallback to store/packs if no categories are found
        return '/store/packs';
      }
    }
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue
    },
  },
  mounted() {
    this.curr = this.currencyCode
  },
	methods: {
    copyIp() {
      let self = this;
      var textarea = document.createElement("textarea");
      textarea.value = self.$parent.ip;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");

      document.body.removeChild(textarea);
      self.ipCopied = true;
      
      setTimeout(()=> {
        self.ipCopied = false;
      }, 2000)
    },
    openSignIn() {
      this.$router.push({path: '/login'});
    },
    openSignUp() {
      this.$router.push({path: '/registration'});
    },
    selectCurr(event) {
      this.curr = event.text;
      this.changeCurrency(event.text)
      localStorage.setItem("currency", event.text);
    },
    changeCurrency(item) {
      this.$emit('changeCurrency', item)
    },
    
	}
}
</script>
